import {playFade} from '../common/help_functions';


export function initColumnsInfo(element) {
    playFade('.columns-info-section .title')
    playFade('.columns-info-section .item')
}